import { isEmpty } from 'lodash-es';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form/immutable';
import { createStructuredSelector } from 'reselect';
import injectSaga from 'utils/injectSaga';
import { validateEmail, validateZipcode } from 'utils/validators';
import LoadingScreen from '../../components/LoadingIndicator';
import { addKlaviyoMember, checkUserEmail } from '../User/actions';
import userSaga from '../User/sagas';
import { makeSelectUser } from '../User/selectors';
import { submitKlaviyoSubscription } from './actions';
import sagas from './sagas';

class KlaviyoPhase1List extends Component {
  constructor() {
    super();
    this.state = {
      submitSuccess: false,
      errors: [],
      isUserExit: false,
      formPayloads: [],
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.renderInputField = this.renderInputField.bind(this);
  }

  componentWillUnmount() {
    this.props.reset();
  }

  componentDidUpdate(prevProps) {
    const { checkingUserEmail, userEmailResult } = this.props.user;
    if (prevProps.user.checkingUserEmail && !checkingUserEmail) {
      const isUserExit = userEmailResult.user;
      this.onFormSubmitPromise(isUserExit);
    }
  }

  onSubmit(values, dispatch, props) {
    this.setState({
      errors: [],
    });
    const valuesObj = values.toJS();
    const email = valuesObj.email && valuesObj.email.trim();
    const zip = valuesObj.zip && valuesObj.zip.trim();

    this.props.checkUserEmail(email);
    this.setState({
      formPayloads: {
        email,
        zip,
      },
    });
  }

  onFormSubmitPromise(isUserExit) {
    const { email, zip } = this.state.formPayloads;
    let payload;
    if (isUserExit) {
      payload = { email, zip };
    } else
      payload = {
        email,
        zip,
        upComingAppointments: 0,
        completedAppointments: 0,
      };
    this.props.addKlaviyoMember(payload);
    return '';
  }

  handleFormChange = () => {
    if (this.state.submitSuccess) {
      this.setState({
        submitSuccess: false,
      });
    }
  };

  renderSuccess = () => {
    const { error, submitFailed, submitSucceeded } = this.props;
    if (!error && !submitFailed && submitSucceeded) {
      this.props.reset();
      this.setState({
        submitSuccess: true,
      });
    }
  };

  renderErrors = () => {
    const { error, submitFailed, valid, type } = this.props;
    const { errors } = this.state;
    if (submitFailed && error) {
      const errors = [];
      errors.push(
        <div className="form-error" key="_error">
          {`${error}`}
        </div>,
      );

      return (
        <div key="form-error" className="error-message">
          Sorry, that didn't work
        </div>
      );
    } else if (isEmpty(errors) && !valid) {
      if (errors.length === 0) {
        return '';
      }
      return (
        <div className={`error-message error-message-${type}`}>
          Oops! That didn’t work.
        </div>
      );
    }
    return null;
  };

  renderInputField(field) {
    if (!field) return;
    const {
      labelText,
      meta: { touched, error, form },
      input: { name, ...inputFields },
      inputType,
      spellCheck,
      inputClass,
      inFieldSuccess,
      maxlength,
      ...otherInputAttributes
    } = field;
    const otherInpAttributes = { ...otherInputAttributes };
    const { submitSucceeded, type } = this.props;
    delete otherInpAttributes.dispatch;
    const fieldId = `${form}.${name}`;
    const containerClass =
      !submitSucceeded && touched && error && error[0] ? 'error' : '';
    let placeholder;
    if (touched && error && error[0]) {
      this.setState({
        errors: [...this.state.errors, error[0]],
      });
      placeholder = error[0];
    } else {
      placeholder = otherInpAttributes.placeholder;
    }
    return (
      <div className={containerClass}>
        <input
          autoComplete="new-password"
          id={fieldId}
          type={inputType}
          name={name}
          className={inputClass}
          placeholder={placeholder}
          {...inputFields}
          maxLength={maxlength}
          spellCheck={spellCheck || 'false'}
        />
        {touched && error && ''}
      </div>
    );
  }

  render() {
    const {
      handleSubmit,
      submitSucceeded,
      submitting,
      ShowinFooter,
      type,
    } = this.props;

    const {
      addingKlaviyoMember,
      addingKlaviyoMemberError,
      checkingUserEmail,
    } = this.props.user;

    if (addingKlaviyoMember || checkingUserEmail) {
      <LoadingScreen hangTight="true" />;
    }

    // if (addingKlaviyoMemberError) {
    //   return (
    //     <div className={`newsletter-${type}__form-wrap`}>
    //       <div className="thank-text"> {addingKlaviyoMemberError}</div>
    //     </div>
    //   );
    // }
    if (submitSucceeded) {
      return (
        <div className={`newsletter-${type}__form-wrap`}>
          <h6 className="thank-text">
            Thanks! We'll be in touch soon if you're a winner!
          </h6>
        </div>
      );
    }

    return (
      <div
        className={
          ShowinFooter
            ? 'hide-phone notify-form-main-wrap'
            : 'notify-form-main-wrap'
        }
      >
        <div className={`newsletter-${type}__form-wrap`}>
          <div id={`${type}Newsletter`} className={`newsletter-${type}`}>
            <form
              onChange={this.handleFormChange}
              id={`${type}NewsletterForm`}
              className={`newsletter-${type}__form notify-form-wrap`}
              onSubmit={handleSubmit((values, dispatch, props) =>
                this.onSubmit(values, dispatch, {
                  ...props,
                  history: this.props.history,
                }),
              )}
            >
              <div className={`newsletter-${type}__form-input-row`}>
                <Field
                  id="footerNewsletterEmail"
                  inputType="email"
                  labelText="Email"
                  inputClass={`input newsletterEmail${type} newsletter-${type}__form-input form-item form-item-${type}`}
                  name="email"
                  component={this.renderInputField}
                  validate={validateEmail}
                  placeholder="Email Address"
                />
                {this.renderErrors()}
              </div>
              <div className={`newsletter-${type}__form-input-row`}>
                <Field
                  id="footerNewsletterZipCode"
                  inputType="tel"
                  labelText="Zip Code"
                  name="zip"
                  maxlength="5"
                  inputClass={`input newsletter-${type}__form-input newsletter-${type}__form-input--inline`}
                  component={this.renderInputField}
                  validate={validateZipcode}
                  inFieldSuccess
                  placeholder="Zip Code"
                />
                <div className={`newsletter-${type}__form-submit hide-notify`}>
                  <button
                    id="footerNewsletterSubmit-1"
                    className={`btn newsletter-${type}__form-btn newsletter-${type}__form-btn--inline btn--secondary ${
                      submitting ? 'is-loading' : ''
                    }`}
                    type="submit"
                    name="button"
                  >
                    SUBMIT
                  </button>
                </div>
              </div>
              <div className={`newsletter-${type}__form-submit show-notify`}>
                <button
                  id="footerNewsletterSubmit-2"
                  className={`btn newsletter-${type}__form-btn newsletter-${type}__form-btn--inline btn--secondary ${
                    submitting ? 'is-loading' : ''
                  }`}
                  type="submit"
                  name="button"
                >
                  SUBMIT
                </button>
              </div>
            </form>
            {this.renderSuccess()}
          </div>
        </div>
      </div>
    );
  }
}
KlaviyoPhase1List = reduxForm({
  form: 'KlaviyoPhase1List',
})(KlaviyoPhase1List);

const mapStateToProps = createStructuredSelector({
  user: makeSelectUser(),
});

const withConnect = connect(
  mapStateToProps,
  { submitKlaviyoSubscription, checkUserEmail, addKlaviyoMember },
);
const withSagaKlaviyoSubscription = injectSaga({
  key: 'klaviyoSub',
  saga: sagas.watchKlaviyoSubscription,
});

const withAddKlaviyoMember = injectSaga({
  key: 'addKlaviyoMember',
  saga: userSaga.watchAddKlaviyoMember,
});

const withSagaCheckUserEmail = injectSaga({
  key: 'checkUserEmail',
  saga: userSaga.watchCheckUserEmail,
});

export default compose(
  withConnect,
  withSagaKlaviyoSubscription,
  withSagaCheckUserEmail,
  withAddKlaviyoMember,
)(KlaviyoPhase1List);
